<div class="packager-jobs-container">
  <evrideo-shaka-packager-job-report
    *ngIf="vm.selectedJob"
    [vm]="vm"
    [loadingMessage]="reportLoadingMessage"
  ></evrideo-shaka-packager-job-report>

  <div class="filters-bar flex row">
    <div class="filter-group">
      <span class="filter-label">Name</span>
      <input
        class="name-filter-input"
        type="search"
        placeholder="Search by media name"
        [ngModel]="vm.nameFilter"
        (ngModelChange)="vm.setNameFilter($event)"
      />
    </div>
    <div class="filter-group">
      <span class="filter-label">Status</span>
      <icn-dropdown
        class="filter-dropdown"
        [position]="'bottom'"
        [placeholder]="'All'"
        [selectedValue]="vm.selectedStatusFilter"
        (selectedValueChange)="vm.setStatusFilter($event)"
      >
        <icn-dropdown-item
          *ngFor="let option of vm.statusFilterOptions"
          [title]="option.label"
          [value]="option.value"
        ></icn-dropdown-item>
      </icn-dropdown>
    </div>
    <div class="filter-group bulk-action">
      <evrideo-hover-button (click)="openBulkCreateDialog()">
        <span>Schedule packager jobs</span>
      </evrideo-hover-button>
    </div>
  </div>

  <div class="table-wrapper">
    <table class="jobs-table">
      <thead>
        <tr>
          <th>Media</th>
          <th>Status</th>
          <th>Schedule date (UTC)</th>
          <th>Last update (UTC)</th>
          <th>Source path</th>
          <th>Report</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let job of vm.jobs">
          <td class="media-cell">
            <a href="/mam/editMedia/{{ job.mediaId }}">{{ job.mediaName }}</a>
          </td>
          <td class="status-cell">{{ job.statusDisplay }}</td>
          <td>{{ job.scheduledAt }}</td>
          <td>{{ job.lastUpdate }}</td>
          <td class="path-cell" [title]="job.sourcePath">
            {{ job.sourcePath }}
          </td>
          <td class="actions-cell">
            <span *ngIf="job.hasProcessLog" (click)="vm.showReport(job)"
              >Report</span
            >
            <span *ngIf="!job.hasProcessLog">—</span>
          </td>
        </tr>
      </tbody>
    </table>
  </div>

  <ngx-smart-modal
    identifier="packagerBulkCreateModal"
    [@.disabled]="true"
    [customClass]="'nsm-centered packager-bulk-modal'"
    [closable]="false"
    [escapable]="true"
    [dismissable]="true"
  >
    <evrideo-packager-bulk-create-dialog
      (completed)="onBulkCreateCompleted()"
    ></evrideo-packager-bulk-create-dialog>
  </ngx-smart-modal>
</div>
